"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightPassengerList = void 0;
const react_1 = __importDefault(require("react"));
const Table_1 = require("../../../Table");
const TableFooter_1 = require("../../../Table/TableFooter");
const utils_1 = require("./utils");
require("./index.scss");
const className = 'flight-passenger-list';
const FlightPassengerList = (props) => {
    const { tableColumns, tableData, sortBy, sortOrder, setSort, setSelectedRows, highlightReservationId, actionsSlot, } = props;
    const tableModificators = (0, utils_1.useTableModificators)(highlightReservationId);
    const tableProps = {
        columns: tableColumns,
        data: tableData,
        defaultSortBy: sortBy,
        defaultSortOrder: sortOrder,
        manualSortBy: true,
        setSort,
        setSelectedRows,
        tableModificators,
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Table_1.Table, { ...tableProps }),
        react_1.default.createElement(TableFooter_1.TableFooter, { actionsSlot: actionsSlot })));
};
exports.FlightPassengerList = FlightPassengerList;
//# sourceMappingURL=index.js.map